export default __webpack_public_path__ + "static/media/63.6d333624.jpg";